module.exports = __webpack_public_path__ + "static/media/azure.36466305.svg";